import { render, staticRenderFns } from "./RecipeDialog.vue?vue&type=template&id=155912e5&v-slot%3Amodal-body=true&"
import script from "./RecipeDialog.vue?vue&type=script&lang=js&"
export * from "./RecipeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports